import React, { useState } from "react";
import styled from "styled-components";

import { resetButtonStyles } from "src/components/ResetButton";
import { fieldHorizontalPadding } from "./styles";

const ShowHidePasswordButton = styled.input`
  ${resetButtonStyles}

  margin-right: ${fieldHorizontalPadding}px;
  margin-bottom: 8px;
  float: right;
  font-size: var(--textS);
  font-weight: 600;
  color: var(--sea);

  &:hover {
    color: var(--darkSea);
  }
`;

type ShowHidePasswordProps = {
  showText: string;
  hideText: string;
  renderComponent: (display: boolean) => JSX.Element;
};

const ShowHidePassword = ({
  renderComponent,
  showText,
  hideText,
}: ShowHidePasswordProps) => {
  const [isPasswordDisplayed, setIsPasswordDisplayed] = useState<boolean>(
    false
  );

  const toggleShowHidePassword = (e: React.FormEvent) => {
    e.preventDefault(); // don't submit the form
    setIsPasswordDisplayed((x) => !x);
  };

  return (
    <>
      <ShowHidePasswordButton
        type="button"
        onClick={toggleShowHidePassword}
        value={isPasswordDisplayed ? hideText : showText}
      />
      {renderComponent(isPasswordDisplayed)}
    </>
  );
};

export default ShowHidePassword;
